import { Button, DialogContent, TextField, useTheme } from '@mui/material';
import React, { useState } from 'react'
import { BiMessageRoundedAdd } from 'react-icons/bi';
import IconButtonEx, { IconButtonExProps } from './IconButtonEx';
import { IsEmpty } from '../Helpers';
import { ResponsiveDialog, ResponsiveDialogHeader, StickyDialogActions } from './responsive';
import useViewportMode from '../hooks/useViewportMode';

export interface TextEditorPopupProps extends Omit<IconButtonExProps, 'onClick'> {
    text: string;
    title: string;
    textUpdated: (text: string) => void;
    icon?: JSX.Element;
}

const TextEditorPopup = ({ text, title, textUpdated, icon = <BiMessageRoundedAdd size={15} />, ...btnProps }: TextEditorPopupProps) => {

    const [note, setNote] = useState<string>(text);
    const [dataHasChanged, setDataHasChanged] = useState<boolean>(false);
    const [open, setOpen] = useState<boolean>(false);
    const theme = useTheme();
    const viewport = useViewportMode();

    const handleDataHasChanged = (value) => {
        setDataHasChanged(true);
        setNote(value);
    }

    const handleSubmit = () => {
        setOpen(false);
        textUpdated(note);

        // setNote(null);
    }

    return (
        <>
            <IconButtonEx hoverContent={title} size='small' onClick={() => setOpen(true)} {...btnProps}>{icon}</IconButtonEx>
            <ResponsiveDialog open={open} fullWidth maxWidth="sm" tabletFullScreen="portrait" aria-label={title}>
                <ResponsiveDialogHeader title={title} onClose={() => setOpen(false)} />
                <DialogContent sx={{ minHeight: 0, overflowY: 'auto' }}>
                    <TextField label="Note"
                        sx={{ marginTop: theme.spacing(1) }}
                        inputRef={input => input && input.focus()}
                        fullWidth
                        name="Content"
                        size="small"
                        variant="outlined"
                        multiline
                        {...(viewport.isDesktop ? { rows: 8 } : { minRows: 6, maxRows: 16 })}
                        error={IsEmpty(note)}
                        value={note}
                        onChange={(e) => handleDataHasChanged(e.target.value)} />
                </DialogContent>
                <StickyDialogActions phoneLayout="stacked" sx={{ margin: 0, padding: theme.spacing(1) }}>
                    <Button onClick={() => setOpen(false)} variant='text' color='inherit'>Cancel</Button>
                    <Button disabled={!dataHasChanged} onClick={handleSubmit} variant='outlined' color='primary'>Submit</Button>
                </StickyDialogActions>
            </ResponsiveDialog>
        </>
    )
}

export default TextEditorPopup
